export function handleGlobalErrorApproval(error, {
    setSnackbarMessage,
    showSnackbar,
    closeModals = () => { },
    disableLoader = () => { },
}) {
    try {
        // Menentukan pesan error (gunakan optional chaining untuk mencegah error)
        const getErrorMessage = (err) => {
            if (err?.response?.status === 500) {
                return "Terjadi kendala pada approval. Silahkan Hubungi Admin STC.";
            }
            if (err?.response?.data?.message) {
                return err.response.data.message;
            }

            if (err?.response?.data?.error) {
                return `${err.response.data.error} Silahkan Hubungi Admin STC.`;
            }

            if (err?.message) {
                return `${err.message} Silahkan Hubungi Admin STC.`;
            }
            return "Terjadi kendala pada approval. Silahkan Hubungi Admin STC.";
        };

        // Dapatkan pesan error
        const message = getErrorMessage(error);

        // Menetapkan pesan ke snackbar
        setSnackbarMessage(message);

        // Menampilkan snackbar
        showSnackbar(true);

        // Menutup semua modal
        closeModals();

        // Menonaktifkan loader setelah timeout
        disableLoader();

    } catch (err) {
        // Tangkap error tidak terduga dan log untuk debugging
        console.error("Unexpected error in handleGlobalErrorApproval:", err);
    }

    // Log error asli untuk debugging
    console.error("Error during request:", error);
}

export function handleError(error, {
    setSnackbarMessage,
    showSnackbar,
    disableLoader = () => { },
    uploadFileError = false,
}) {
    try {
        // Menentukan pesan error (gunakan optional chaining untuk mencegah error)
        const getErrorMessage = (err) => {
            if (uploadFileError) {
                return "Terjadi kendala pada upload file. Silahkan Hubungi Admin STC.";
            }
            if (err?.response?.status === 500) {
                return "Terjadi kendala. Silahkan Hubungi Admin STC.";
            }
            if (err?.response?.data?.message) {
                return err.response.data.message;
            }

            if (err?.response?.data?.error) {
                return `${err.response.data.error} Silahkan Hubungi Admin STC.`;
            }

            if (err?.message) {
                return `${err.message} Silahkan Hubungi Admin STC.`;
            }
            return "Terjadi kendala pada approval. Silahkan Hubungi Admin STC.";
        };

        // Dapatkan pesan error
        const message = getErrorMessage(error);

        // Menetapkan pesan ke snackbar
        setSnackbarMessage(message);

        // Menampilkan snackbar
        showSnackbar(true);

        // Menonaktifkan loader setelah timeout
        disableLoader();

    } catch (err) {
        // Tangkap error tidak terduga dan log untuk debugging
        console.error("Unexpected error in handleError:", err);
    }

    // Log error asli untuk debugging
    console.error("handleError Error during request:", error);
}

